/* eslint-disable complexity */
/* eslint-disable no-magic-numbers */
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { FlatTableHead, FlatTableRow, FlatTableHeader } from 'carbon-react/lib/components/flat-table';

import { useWorkspaceOrganisationSelector } from '@futrli/shared-services';
import { VisuallyHidden } from '@futrli/ui-components/components/visually-hidden';

import { getFormattedYearToDate } from '../../utils';

interface Props {
  isBalanceSheet: boolean;
}

export const CategoryTableHeader = ({ isBalanceSheet }: Props) => {
  const intl = useIntl();
  const { organisationId: tempOrganisationId, workspaceId: tempWorkspaceId } = useParams();
  const organisationId = tempOrganisationId || '';
  const workspaceId = tempWorkspaceId || '';
  const organisation = useWorkspaceOrganisationSelector(workspaceId, organisationId);

  return (
    // Add z index 0
    <FlatTableHead>
      <FlatTableRow>
        <FlatTableHeader>
          <FormattedMessage id="reporting.grouping.accounts" defaultMessage="Accounts" />
        </FlatTableHeader>
        <FlatTableHeader width={isBalanceSheet ? 300 : 120}>
          {isBalanceSheet ? (
            <FormattedMessage id="predict.switch_rule" defaultMessage="Switch rule" />
          ) : (
            <FormattedMessage id="predict.days_to_pay" defaultMessage="Days to pay" />
          )}
        </FlatTableHeader>
        <FlatTableHeader width={120}>
          <FormattedMessage
            id="predict.ytd"
            defaultMessage="Yr to {dateFormat}"
            values={{ dateFormat: getFormattedYearToDate(intl, organisation?.datasource?.sync_status_modified) }}
          />
        </FlatTableHeader>
        {/* Actions column */}
        <FlatTableHeader width={132} px="8px">
          <VisuallyHidden>
            <FormattedMessage id="predict.actions" defaultMessage="Actions" />
          </VisuallyHidden>
        </FlatTableHeader>
      </FlatTableRow>
    </FlatTableHead>
  );
};
